import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Snackbar,
  Toolbar,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDropDown from "../CustomComponents/CustomDropDown";
import CustomTextField from "../CustomComponents/CustomTextField";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import StlapFooter from "../CustomComponents/StlapFooter";
import { BranchAction } from "../Store/Branch";
import { NachApprovalReducerAction } from "../Store/NachApprovalReducer";
import { VerificationModalReducerAction } from "../Store/VerificationModalReducer";
import store from "../Store";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const NachVerification = () => {
  //Getting approval data from Store
  const editLock = useSelector((state) => state.nachVerification.editLock);

  const modalData = useSelector((state) => state.nachVerification.modalValue);
  //Setting dispatch state
  const dispatch = useDispatch();
  //Checking verified Status for hiding and disabled fields
  const [verifiedStatus, setVerifiedStatus] = useState(false);
  const [editLockStatus, setEditLockStatus] = useState();
  const [editButtonHide, setEditButtonHide] = useState();
  //state which maintain to show/hide the remarks column
  const [showRemark, setShowRemark] = useState(false);
  //
  const [remarkValue, setRemarkValue] = useState("");
  //Filter conditions State value
  const [branchArray, setBranchArray] = useState([]);
  const [branchValue, setBranchValue] = useState(null);
  const [applicationArray, setApplicationArray] = useState([]);
  const [applicationValue, setApplicationValue] = useState(null);
  const [mandateArray, setMandateArray] = useState([]);
  const [mandateValue, setMandateValue] = useState(null);
  const [applicationStore, setApplicationStore] = useState([]);
  const [UMRNNumer, setUMRNNumber] = useState("");
  //Dialog state maintaining while submission
  const [UMRNDialogOpen, setUMRNDialogOpen] = useState(false);
  //Dialog Title for Success
  const [successTitle, setSuccessTitle] = useState("");
  //Dialog content for success
  const [dialogMessage, setDialogMessage] = useState("");
  //Vaidation section for status fields
  const statusIsValid = modalData.status !== "" && modalData.status !== null;
  const branchIsValid = branchValue !== "" && branchValue !== null;
  const applicationNumIsValid =
    applicationValue !== "" && applicationValue !== null;
  const mandataIsValid = mandateValue !== "" && mandateValue !== null;
  const remarkIsValid =
    modalData.status === "VERIFIED"
      ? true
      : remarkValue !== "" &&
        remarkValue !== null &&
        remarkValue.length <= 4000;
  const [remarkIsTouched, setRemarkIsTouched] = useState(false);
  const [statusIsTouched, setStatusIsTouched] = useState(false);
  const [branchIsTouched, setBranchIsTouched] = useState(false);
  const [applicationIsTouched, setApplicationTouched] = useState(false);
  const [mandateIsTouched, setMandateIsTouched] = useState(false);
  //Maintaining Button State for final dialog
  const [okCompState, setOkCompState] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState([]);
  const statusHasError = statusIsTouched && !statusIsValid;
  const branchHasError = branchIsTouched && !branchIsValid;
  const applicationHasError = applicationIsTouched && !applicationNumIsValid;
  const mandateHassError = mandateIsTouched && !mandataIsValid;
  const remarkHasError = remarkIsTouched && !remarkIsValid;
  //Edit lock dialog state management
  const [editLockDialogOpen, setEditLockDialogOpen] = useState();
  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [state, setState] = React.useState({
    open: false,
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal, open } = state;
  const [alert, setAlert] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setState(SnackPosition);
  }, []);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };
  //Initial Object
  const [checkStatus, setCheckStatus] = useState({
    status: "",
    remarks: "",
  });
  //Methods
  const branchOnChangeHandler = (value) => {
    let { editLockFlag, branch, applicationNumber } = editLock;
    if (!editLockFlag) {
      releaseLock(branch, applicationNumber);
    }
    dispatch(VerificationModalReducerAction.resetValues());
    dispatch(
      VerificationModalReducerAction.updateEditLockBranch(
        value === null ? "" : value.label
      )
    );
    setApplicationArray([]);
    // setMandateIsTouched(false);
    // setApplicationTouched(false);
    // setStatusIsTouched(false);
    if (value !== null) {
      dispatch(BranchAction.updateInitialLoad(false));
      dispatch(BranchAction.updateHeaderBranchDetails(value.label));
      getApplicationNumberByBranch(value.label);
    }

    setApplicationValue("");
    setMandateArray([]);
    setMandateValue("");
    setRemarkValue("");
    setShowRemark(false);
    setVerifiedStatus(false);

    setBranchValue(value == null ? "" : value.label);
    // const applicationArray = applicationStore.filter((item) => {
    //   return item.branch === value.label;
    // });

    // const app = applicationArray.map((itm) => itm.applicationNum).sort();
    // setApplicationArray([...new Set(app)]);
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const getApplicationNumberByBranch = async (value) => {
    const branchCodeValue = getSelectedBranchCode(value);
    const response = await axios.post("/nach/getApplicationNumByBranch", {
      branch: value,
      branchCode: branchCodeValue,
      status: ["INWARD", "VERIFIED", "REJECTED"],
    });
    setApplicationArray(response.data.sort());
  };
  const applicationNumberOnChangeHandler = (value) => {
    // setMandateIsTouched(false);
    let { editLockFlag, branch, applicationNumber } = editLock;
    if (!editLockFlag) {
      releaseLock(branch, applicationNumber);
    }
    dispatch(VerificationModalReducerAction.resetValues());
    dispatch(
      VerificationModalReducerAction.updateEditLockApplicationNumber(value)
    );
    setMandateArray([]);
    setMandateValue("");
    // setStatusIsTouched(false);
    setVerifiedStatus(false);
    setApplicationValue(value);
    setRemarkValue("");
    setShowRemark(false);
    getMandateNumberBasedOnApplicationNumber(value);
    // const mandateArray = applicationStore.filter((item) => {
    //   return value === item.applicationNum;
    // });
    // const arr = mandateArray.map((itm) => {
    //   return {
    //     label: `${itm.mandateNum} - ${itm.applicantName}`,
    //     value: itm.mandateNum,
    //   };
    // });
    // setMandateArray(arr);
    // try {
    //   changeAppNumReq(value);
    // } catch {}
  };
  const editLockOkButonHandler = () => {
    setEditButtonHide(true);
    setVerifiedStatus(true);
    setEditLockDialogOpen(false);
  };
  const getMandateNumberBasedOnApplicationNumber = async (value) => {
    const response = await axios.post("/nach/getMandateNumByAppNum", {
      applicationNum: value,
      status: ["INWARD", "VERIFIED", "REJECTED"],
    });
    let lockStatus = response.data[0].editLock;
    dispatch(VerificationModalReducerAction.updateEditLockFlag(lockStatus));
    setEditLockStatus(lockStatus);
    const arr = response.data.map((itm) => {
      return itm.mandateNum;
    });
    setMandateArray(arr);
  };
  const mandateNumberOnChangeHandler = (value) => {
    dispatch(VerificationModalReducerAction.resetValues());
    setRemarkValue("");
    //setVerifiedStatus(false);
    // setStatusIsTouched(false);
    setShowRemark(false);
    if (value !== null) {
      setMandateValue(value);
      try {
        changeAppNumReq(value);
      } catch {}
    } else {
      setMandateValue("");
    }
  };
  //Dialog onOpen and onClose methods for UMRN
  const handleUMRNDialogClickOpen = () => {
    setOkCompState(false);
    setUMRNDialogOpen(true);
    setSuccessTitle("Information");
    setDialogMessage("NACH Mandate Verified Successfully");
  };

  const handleUMRNDialogClose = () => {
    resettingLogics();
  };
  const resettingLogics = () => {
    setUMRNDialogOpen(false);
    setApplicationArray([]);
    setApplicationValue("");
    setMandateArray([]);
    setMandateValue("");
    setBranchValue("");
    setRemarkValue("");
    setShowRemark(false);
    setStatusIsTouched(false);
    setBranchIsTouched(false);
    setApplicationTouched(false);
    setMandateIsTouched(false);
    setRemarkIsTouched(false);
    dispatch(VerificationModalReducerAction.resetValues());
  };
  //Getting app number
  const getData = async () => {
    const response = await axios.post("/nach/getAppNumAndBranchByStatus", [
      "INWARD",
      "VERIFIED",
      "REJECTED",
    ]);
    setApplicationStore(response.data);
  };
  //Getting data based on application num
  const changeAppNumReq = async (value) => {
    try {
      const response = await axios.post("/nach/getNachData", {
        mandateNum: value,
      });

      if (editLockStatus) {
        setEditLockDialogOpen(true);
      } else {
        if (
          response.data.status === "VERIFIED" ||
          response.data.status === "REJECTED"
        ) {
          setEditButtonHide(false);
          setVerifiedStatus(true);
          if (response.data.status === "VERIFIED") {
            setShowRemark(false);
          } else {
            setShowRemark(true);
          }
        } else {
          setVerifiedStatus(false);
        }
      }
      //setCheckStatus(response.data.status);
      setCheckStatus((pre) => {
        return {
          ...pre,
          status: response.data.status,
          remarks: response.data.remarks,
        };
      });
      dispatch(VerificationModalReducerAction.updatemodalValues(response.data));
      setRemarkValue(response.data.rejectionRemarks);
    } catch {}
  };

  const submitButtonOnChangeHandler = () => {
    setStatusIsTouched(true);
    setBranchIsTouched(true);
    setApplicationTouched(true);
    setMandateIsTouched(true);
    setRemarkIsTouched(true);
    if (
      statusIsValid &&
      branchIsValid &&
      applicationNumIsValid &&
      mandataIsValid &&
      remarkIsValid
    ) {
      if (
        checkStatus.status === modalData.status &&
        checkStatus.remarks === remarkValue
      ) {
        setOkCompState(true);
        setUMRNDialogOpen(true);
        setSuccessTitle("Information");
        setDialogMessage("No Changes Made.");
      } else {
        setconfirmationDialogOpen(true);
      }
    }
  };
  //Handling dialogs for confirmation modal
  const [confirmationDialogOpen, setconfirmationDialogOpen] = useState(false);
  const confirmationDialogClose = () => {
    setconfirmationDialogOpen(false);
  };
  const confirmationDialogOkButtonClickHandler = () => {
    try {
      verifyStatusUpdation();
    } catch {
      console.log("Priniting Error");
    }
    setconfirmationDialogOpen(false);
  };
  //Send Status updation on verification
  const verifyStatusUpdation = async () => {
    const response = await axios.post("/nach/nachStatusChange", {
      mandateNum: mandateValue,
      applicationNum: modalData.applicationNum,
      status: modalData.status,
      mode: modalData.status,
      remarks: remarkValue,
    });
    setUMRNNumber(response.data.umrnNumber);
    if (modalData.status === "VERIFIED") {
      handleUMRNDialogClickOpen();
    } else {
      handleUMRNDialogClickOpen();
      setOkCompState(false);
      setUMRNDialogOpen(true);
      setSuccessTitle("Information");
      setDialogMessage("NACH Mandate Rejected Successfully");
      // setState((pre) => {
      //   return { ...pre, vertical: "bottom", horizontal: "left" };
      // });
      // setAlertType("success");
      // setMessage("Nach Rejected Sucessfully");
      // openAlertHandler();
    }
  };

  const saveRef = useRef(null);
  const cancelRef = useRef(null);
  const yesRef = useRef(null);
  const okRef = useRef(null);
  const okUMRef = useRef(null);
  const modifyRef = useRef(null);
  const okEditRef = useRef(null);
  const clearRef = useRef(null);
  useEffect(() => {
    //This useEffect for Page refresh
    getVerificationStatus();
    window.addEventListener("beforeunload", alertUser);
    window.addEventListener("unload", call);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
      window.removeEventListener("unload", call);
    };
  }, []);
  const alertUser = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };
  const getVerificationStatus = async () => {
    try {
      const nachLovValues = await axios.post("/lovMaster/getLovValues", {
        moduleId: "MD002",
      });
      const verificationStatus = nachLovValues.data["Verification Status"].map(
        (type) => {
          return type.lovValues;
        }
      );
      setVerificationStatus(verificationStatus);
    } catch (e) {}
  };
  const call = () => {
    let editLockFlag = store.getState().nachVerification.editLock.editLockFlag;
    let branchValue = store.getState().nachVerification.editLock.branch;
    let applicationNumber =
      store.getState().nachVerification.editLock.applicationNumber;
    if (!editLockFlag) {
      releaseLock(branchValue, applicationNumber);
    }
  };
  const releaseLock = async (branch, applicationNumber) => {
    if (branch !== "" && applicationNumber !== "") {
      try {
        const branchCodeValue = getSelectedBranchCode(branch);
        const response = await axios.post("/nach/editLockUpdate", {
          applicationBranch: branch,
          applicationBranchCode: branchCodeValue,
          applicationNum: applicationNumber,
        });
      } catch {}
    }
  };
  useEffect(() => {
    dispatch(VerificationModalReducerAction.resetValues());
    const branchArr = GetBranchDetails();
    setBranchArray(branchArr);

    // Method will call when the component unmount
    let branchValue = store.getState().nachVerification.editLock.branch;
    let applicationNumber =
      store.getState().nachVerification.editLock.applicationNumber;
    let editLockFlag = store.getState().nachVerification.editLock.editLockFlag;
    if (!editLockFlag) {
      releaseLock(branchValue, applicationNumber);
    }
  }, []);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, [UMRNDialogOpen, okCompState]);

  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "nachVerification",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      if (UMRNDialogOpen) {
        if (okCompState) {
          setUMRNDialogOpen(false);
        } else {
          handleUMRNDialogClose();
        }
      } else {
        confirmationDialogClose();
      }
    }
    let refList = {
      saveRef: saveRef,
      cancelRef: cancelRef,
      yesRef: yesRef,
      modifyRef: modifyRef,
      okRef: okRef.current !== null ? okRef : null,
      //okUMRef: okUMRef.current !== null ? okUMRef : null,
      okEditRef: okEditRef.current !== null ? okEditRef : null,
    };
    if (event.ctrlKey) {
      if (charCode === "d") {
        clearRef.current.click();
      } else if (charCode === "k" && okUMRef.current !== null) {
        okUMRef.current.click();
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "nachVerification",
          })
        );
      }
    }
  };

  const editButtonHandler = () => {
    setVerifiedStatus(false);
    setShowRemark(false);
    setRemarkValue("");
  };
  const clearButtonHandler = () => {
    let { editLockFlag, branch, applicationNumber } = editLock;
    if (!editLockFlag) {
      releaseLock(branch, applicationNumber);
    }
    dispatch(VerificationModalReducerAction.resetValues());
    setStatusIsTouched(false);
    setBranchIsTouched(false);
    setApplicationTouched(false);
    setMandateIsTouched(false);
    setOkCompState(false);
    setShowRemark(false);
    setVerifiedStatus(false);
    setBranchValue("");
    setApplicationArray([]);
    setApplicationValue("");
    setMandateArray([]);
    setMandateValue("");
    setUMRNNumber("");
    setRemarkValue("");
  };
  return (
    <React.Fragment>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer
          id="accord"
          title="Verification"
          initialOpen={true}
          sx={{ margin: "8px !important" }}
        >
          <Box sx={{ marginTop: "-1%" }}>
            {verifiedStatus && !editButtonHide && (
              <Box
                sx={{
                  direction: "rtl",
                }}
              >
                <Tooltip title="Ctrl+M" placement="top">
                  <Button
                    variant="contained"
                    onClick={editButtonHandler}
                    ref={modifyRef}
                  >
                    Edit
                  </Button>
                </Tooltip>
              </Box>
            )}

            <Grid container rowSpacing={0} columnSpacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Branch"
                  label="Branch"
                  autoCompleteValues={branchArray}
                  value={branchValue ? branchValue : null}
                  required={true}
                  onBlur={() => {
                    setBranchIsTouched(true);
                  }}
                  onChange={(e, value) => {
                    branchOnChangeHandler(value);
                  }}
                />
                {branchHasError && (
                  <p className="error">Please Select Branch</p>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Application Number"
                  label="Application Number"
                  autoCompleteValues={applicationArray}
                  value={applicationValue ? applicationValue : null}
                  required={true}
                  onBlur={() => {
                    setApplicationTouched(true);
                  }}
                  onChange={(event, value) => {
                    applicationNumberOnChangeHandler(value);
                  }}
                />
                {applicationHasError && (
                  <p className="error">Please Select Application Number</p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Mandate Number"
                  label="Mandate Number"
                  autoCompleteValues={mandateArray}
                  value={mandateValue ? mandateValue : null}
                  required={true}
                  onBlur={() => {
                    setMandateIsTouched(true);
                  }}
                  onChange={(event, value) => {
                    mandateNumberOnChangeHandler(value);
                  }}
                />
                {mandateHassError && (
                  <p className="error">Please Select Mandate Number</p>
                )}
              </Grid>

              {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Customer ID"
            variant="standard"
            placeholder="Enter Customer ID"
            disabled={true}
            value={modalData.customerId}
          />
        </Grid> */}
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Applicant Name"
                  variant="standard"
                  placeholder="Applicant Name"
                  disabled={true}
                  value={modalData.customerName.toUpperCase()}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Mandate Bank"
                  variant="standard"
                  placeholder="Mandate Bank"
                  disabled={true}
                  value={modalData.mandateBank}
                />
              </Grid>

              {!verifiedStatus && (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  {/* <CustomDropDown
                    dropDownValue={[
                      { key: 1, value: "VERIFIED", text: "VERIFIED" },
                      { key: 2, value: "REJECTED", text: "REJECTED" },
                    ]}
                    onChange={(e) => {
                      dispatch(
                        VerificationModalReducerAction.updateStatus(
                          e.target.value
                        )
                      );
                      if (e.target.value === "REJECTED") {
                        setShowRemark(true);
                      } else {
                        setShowRemark(false);
                        setRemarkValue("");
                      }
                    }}
                  /> */}
                  <CustomAutoComplete
                    variant="standard"
                    type="text"
                    placeholder="Select Status"
                    label="Status"
                    autoCompleteValues={verificationStatus}
                    value={modalData.status ? modalData.status : null}
                    required={true}
                    disabled={verifiedStatus}
                    onBlur={() => {
                      setStatusIsTouched(true);
                    }}
                    onChange={(event, value) => {
                      dispatch(
                        VerificationModalReducerAction.updateStatus(value)
                      );
                      if (value === "REJECTED") {
                        setShowRemark(true);
                      } else {
                        setShowRemark(false);
                        setRemarkValue("");
                      }
                    }}
                  />
                  {statusHasError && (
                    <p className="error">Please Select Status</p>
                  )}
                </Grid>
              )}
              {verifiedStatus && (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Status"
                    variant="standard"
                    disabled={true}
                    value={modalData.initialStatus}
                  />
                </Grid>
              )}
              {showRemark && (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Remarks"
                    required={true}
                    variant="standard"
                    disabled={verifiedStatus}
                    value={remarkValue}
                    onChange={(e) => {
                      setRemarkValue(e.target.value);
                    }}
                    onBlur={() => {
                      setRemarkIsTouched(true);
                    }}
                  />
                  {remarkHasError && (
                    <p className="error">Please Enter Valid Remarks</p>
                  )}
                </Grid>
              )}
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "8px",
                marginBottom: "4px",
                gap: "8px",
              }}
            >
              {!verifiedStatus && (
                <Tooltip title="Ctrl+S" placement="top">
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{ height: "2rem", fontWeight: "bold" }}
                    onClick={submitButtonOnChangeHandler}
                    ref={saveRef}
                  >
                    Submit
                  </Button>
                </Tooltip>
              )}
              <Tooltip title="Ctrl+D" placement="top">
                <Button
                  variant="contained"
                  type="submit"
                  sx={{
                    height: "2rem",
                    fontWeight: "bold",
                    backgroundColor: "black",
                  }}
                  onClick={clearButtonHandler}
                  ref={clearRef}
                >
                  Clear
                </Button>
              </Tooltip>
            </Box>

            <Dialog
              open={confirmationDialogOpen}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">Confimation</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {`${
                    modalData.status === "VERIFIED" ? "Verify" : "Reject"
                  } NACH Mandate ?`}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Tooltip title="Ctrl+Q" placement="top">
                  <Button onClick={confirmationDialogClose} ref={cancelRef}>
                    Cancel
                  </Button>
                </Tooltip>
                <Tooltip title="Ctrl+Y" placement="top">
                  <Button
                    onClick={confirmationDialogOkButtonClickHandler}
                    ref={yesRef}
                  >
                    Yes
                  </Button>
                </Tooltip>
              </DialogActions>
            </Dialog>
            <Dialog
              open={UMRNDialogOpen}
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle>{successTitle}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {dialogMessage}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {!okCompState && (
                  <Tooltip title="Ctrl+K" placement="top">
                    <Button onClick={handleUMRNDialogClose} ref={okUMRef}>
                      OK
                    </Button>
                  </Tooltip>
                )}
                {okCompState && (
                  <Tooltip title="Ctrl+K" placement="top">
                    <Button
                      onClick={() => {
                        setUMRNDialogOpen(false);
                      }}
                      ref={okRef}
                    >
                      OK
                    </Button>
                  </Tooltip>
                )}
              </DialogActions>
            </Dialog>
            <Snackbar
              open={alert}
              autoHideDuration={6000}
              anchorOrigin={{ vertical, horizontal }}
              onClose={closeAlertHandler}
            >
              <Alert
                onClose={closeAlertHandler}
                severity={alertType}
                variant="filled"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
          </Box>
        </AccordianContainer>
      </Box>

      <StlapFooter />

      <Dialog
        open={editLockDialogOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Information</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            This Record is Being Edited by Other User, Click OK to Navigate View
            Screen.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+K" placement="top">
            <Button
              onClick={() => {
                editLockOkButonHandler();
              }}
              ref={okEditRef}
            >
              OK
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NachVerification;
